import { ANALYTIC_MODULE_CONSTS as AMC } from '../consts'
import services from '@/services/ascentiaServiceIndex'

const state = {
  amcAnalyticModules: [],
  amcFeatures: [],
  amcAnalyticTrendsDataResults: [],
  amcAnalyticComparisonDataResults: {},
  amcAnalyticComparisonDataResultsMissingTails: [],
  amcAnalyticComparisonFilters: {},
  analyticModules: [],
  analyticModule: {},
  allAnalyticModulesLoading: false,
  saveModuleToastNotification: false,
  pagePlotFeatures: [],
  ascentiaAnalyticsWithAlertTypes: [],
  customMxRecEntry: '',
  savingCustomMxRecEntry: false,
}

const getters = {
  mappedAmcAnalyticModules: (state, getters, rootState, rootGetters) => {
    if (state.amcAnalyticModules) {
      const selections = rootGetters['globalFilter/selections']

      return state.amcAnalyticModules
        .filter(
          item =>
            selections.length === 0 ||
            selections.filter(
              selection =>
                item.airlineIds.includes(selection.airlineId) &&
                selection.masterModelId === item.masterModelId,
            ).length > 0,
        )
        .map(item => {
          return {
            ...item,
            analyticModuleId: item.id,
            text: item.displayName,
            value: item.id,
          }
        })
    }
    return []
  },
  mappedAmcAnalyticModulesAll: state => {
    if (state.amcAnalyticModules) {
      return state.amcAnalyticModules
        .filter(item => item.isActive)
        .map(item => {
          return {
            ...item,
            analyticModuleId: item.id,
            text: item.displayName,
            value: item.id,
          }
        })
    }
    return []
  },
  mappedAmcFeatures: state => {
    if (state.amcFeatures) {
      return state.amcFeatures
        .filter(feature => feature.isUserPlottable)
        .map(item => {
          return {
            ...item,
            analyticId: item.analytic.id,
            analyticModuleId: item.analyticModule.id,
            featureId: item.id,
            riskScoreId: item.id,
            text: item.displayName,
            value: item.id,
          }
        })
    }
    return []
  },
  mappedAnalyticModules: state => {
    if (state.analyticModules) {
      return state.analyticModules.map(analytic => {
        return {
          ...analytic,
          text: analytic.displayName,
          value: analytic.id,
        }
      })
    }
    return []
  },

  getPagePlotFeatures: state => {
    return state.pagePlotFeatures.sort((a, b) => b.tabIndex - a.tabIndex)
  },
}

const mutations = {
  [AMC.UPDATE_AMC_ANALYTIC_MODULES]: (state, data) =>
    (state.amcAnalyticModules = data),
  [AMC.UPDATE_AMC_FEATURES]: (state, data) => (state.amcFeatures = data),
  [AMC.UPDATE_AMC_ANALYTIC_TRENDS_DATA]: (state, data) => {
    state.amcAnalyticTrendsDataResults = data
  },
  [AMC.UPDATE_AMC_PAGE_PLOT_FEATURES_WITH_SELECTOR]: (state, data) => {
    const idx = state.pagePlotFeatures.findIndex(x => x.plotId === data.plotId)
    if (idx > -1) {
      state.pagePlotFeatures[idx].features = [data.featureData]
    }
  },
  [AMC.UPDATE_AMC_PAGE_PLOT_FEATURES]: (state, data) => {
    const idx = state.pagePlotFeatures.findIndex(x => x.plotId === data.plotId)
    if (idx > -1) {
      // Pageplot already exists so check features
      const ifx = state.pagePlotFeatures[idx].features.findIndex(
        f => f.id === data.featureData.id,
      )
      if (ifx > -1) {
        // Feature already exists then update
        state.pagePlotFeatures[idx].features.splice(ifx, 1, data.featureData)
      } else {
        // Else add the feature
        state.pagePlotFeatures[idx].features.push(data.featureData)
      }
    } else {
      // Inser the pageplot with features
      state.pagePlotFeatures.push({
        plotId: data.plotId,
        features: [data.featureData],
      })
    }
  },
  [AMC.UPDATE_AMC_ANALYTIC_COMPARISON_DATA]: (state, data) => {
    state.amcAnalyticComparisonDataResults = data
  },
  [AMC.UPDATE_AMC_ANALYTIC_COMPARISON_DATA_MISSING_TAILS]: (state, data) => {
    state.amcAnalyticComparisonDataResultsMissingTails = data
  },
  [AMC.UPDATE_AMC_ANALYTIC_COMPARISON_FILTERS]: (state, filters) =>
    (state.amcAnalyticComparisonFilters = filters),

  [AMC.UPDATE_ANALYTIC_MODULES]: (state, data) =>
    (state.analyticModules = data),
  [AMC.UPDATE_ANALYTIC_MODULE]: (state, data) => (state.analyticModule = data),
  [AMC.UPDATE_CUSTOM_MX_REC_ENTRY]: (state, data) =>
    (state.customMxRecEntry = data),
  [AMC.SAVE_MODULE_TOAST_NOTIFICATION]: (state, data) =>
    (state.saveModuleToastNotification = data),
  [AMC.ALL_ANALYTIC_MODULES_LOADING]: (state, data) =>
    (state.allAnalyticModulesLoading = data),
  [AMC.UPDATE_ASCENTIA_ANALYTICS_WITH_ALERT_TYPES]: (state, data) => {
    state.ascentiaAnalyticsWithAlertTypes = data
  },
  [AMC.SAVING_CUSTOM_MX_REC_ENTRY]: (state, data) =>
    (state.savingCustomMxRecEntry = data),
}

const actions = {
  async [AMC.GET_AMC_ANALYTIC_MODULES]({ commit }) {
    try {
      const response = await services.analyticModule.getData('analyticModules')
      const data = response.data
      commit(AMC.UPDATE_AMC_ANALYTIC_MODULES, data)
    } catch (error) {
      console.log(AMC.GET_AMC_ANALYTIC_MODULES + ': error ' + error)
    }
  },

  async [AMC.GET_AMC_FEATURES]({ commit }) {
    try {
      const response = await services.analyticModule.getData('features')
      const data = response.data
      commit(AMC.UPDATE_AMC_FEATURES, data)
    } catch (error) {
      console.log(AMC.GET_AMC_FEATURES + ': error ' + error)
    }
  },

  async [AMC.GET_AMC_ANALYTIC_TRENDS_DATA]({ commit }, params) {
    try {
      commit(AMC.UPDATE_AMC_ANALYTIC_TRENDS_DATA, [])

      if (
        params.isInvalidPlot !== true &&
        params.featureId !== null &&
        params.tailName !== null
      ) {
        const response = await services.analyticModule.getData(
          'analyticTrendsData',
          params,
          true,
        )
        const data = response.data
        commit(AMC.UPDATE_AMC_ANALYTIC_TRENDS_DATA, data)
      } else {
        commit(AMC.UPDATE_AMC_ANALYTIC_TRENDS_DATA, [])
      }
    } catch (error) {
      console.log(AMC.GET_AMC_ANALYTIC_TRENDS_DATA + ': error ' + error)
    }
  },

  async [AMC.GET_AMC_ANALYTIC_COMPARISON_DATA]({ commit }, selector) {
    try {
      commit(AMC.UPDATE_AMC_ANALYTIC_COMPARISON_DATA_MISSING_TAILS, [])
      commit(AMC.UPDATE_AMC_ANALYTIC_COMPARISON_DATA, {})

      if (selector.isInvalidPlot !== true) {
        commit(AMC.UPDATE_AMC_ANALYTIC_COMPARISON_FILTERS, selector)

        const filters = {
          airlineIds: state.amcAnalyticComparisonFilters.airlineIds,
          featureIds: state.amcAnalyticComparisonFilters?.featureIds || [],
          features: state.amcAnalyticComparisonFilters.features,
          startDate: state.amcAnalyticComparisonFilters.startDate,
          endDate: state.amcAnalyticComparisonFilters.endDate,
        }

        const anyInvalidFeatureIds =
          filters.featureIds.filter(id => id === undefined || id === null)
            .length > 0

        if (!anyInvalidFeatureIds) {
          const response = await services.analyticModule.getData(
            'analyticComparisonData',
            filters,
            true,
          )

          const massagedData = {
            ...response,
            tails: (response.tails || []).filter(tail => {
              const strippedTail = tail.tail.split(' ')[0]
              return state.amcAnalyticComparisonFilters.tails.includes(
                strippedTail,
              )
            }),
          }

          const allResponseTails = (response.tails || []).map(
            tail => tail.tail.split(' ')[0],
          )
          let missingTails = []

          if ((state.amcAnalyticComparisonFilters.tails || []).length > 0) {
            missingTails = (
              state.amcAnalyticComparisonFilters.tails || []
            ).filter(tail => !allResponseTails.includes(tail))
          }

          commit(AMC.UPDATE_AMC_ANALYTIC_COMPARISON_DATA, massagedData)
          commit(
            AMC.UPDATE_AMC_ANALYTIC_COMPARISON_DATA_MISSING_TAILS,
            missingTails,
          )
        }
      }
    } catch (error) {
      console.log(AMC.GET_AMC_ANALYTIC_COMPARISON_DATA + ': error ' + error)
    }
  },
  async [AMC.SET_AMC_PAGE_PLOT_FEATURES]({ commit }, data) {
    try {
      commit(AMC.UPDATE_AMC_PAGE_PLOT_FEATURES, data)
    } catch (error) {
      console.log(AMC.SET_AMC_PAGE_PLOT_FEATURES + ': error ' + error)
    }
  },
  async [AMC.SET_AMC_PAGE_PLOT_FEATURES_WITH_SELECTOR]({ commit }, data) {
    try {
      commit(AMC.UPDATE_AMC_PAGE_PLOT_FEATURES_WITH_SELECTOR, data)
    } catch (error) {
      console.log(
        AMC.SET_AMC_PAGE_PLOT_FEATURES_WITH_SELECTOR + ': error ' + error,
      )
    }
  },
  async [AMC.GET_ANALYTIC_MODULES](
    { commit },
    isAdmin = false,
    args = { refresh: true },
  ) {
    commit(AMC.ALL_ANALYTIC_MODULES_LOADING, true)
    try {
      const response = await services.analyticModule.getData(
        'analyticModules',
        isAdmin,
        args.refresh,
      )
      const data = response.data
      commit(AMC.UPDATE_ANALYTIC_MODULES, data)
      commit(AMC.ALL_ANALYTIC_MODULES_LOADING, false)
    } catch (error) {
      console.log(AMC.GET_AMC_ANALYTIC_MODULES + ': error ' + error)
    }
  },

  async [AMC.GET_CUSTOM_MX_REC_ENTRY]({ commit }, params) {
    try {
      const response = await services.analyticModule.getData(
        'customRecommendationEntry',
        params,
        true,
      )
      const data = response.data
      commit(AMC.UPDATE_CUSTOM_MX_REC_ENTRY, data)
    } catch (error) {
      console.log(AMC.GET_CUSTOM_MX_REC_ENTRY + ': error ' + error)
    }
  },

  async [AMC.GET_ANALYTIC_MODULE]({ commit }, { id, isAdmin }) {
    try {
      const response = await services.analyticModule.getData(
        'analyticModule',
        {
          id,
          isAdmin,
        },
        true,
      )
      const data = response.data
      commit(AMC.UPDATE_ANALYTIC_MODULE, data)
    } catch (error) {
      console.log(AMC.GET_ANALYTIC_MODULE + ': error ' + error)
    }
  },
  async [AMC.SAVE_ANALYTIC_MODULE]({ commit, dispatch }, analyticModule) {
    commit(AMC.SAVE_MODULE_TOAST_NOTIFICATION, false)
    try {
      const response = await services.analyticModule.saveData(
        'saveAnalyticModule',
        analyticModule,
      )
      if (response.status === 200 && response.data !== 0) {
        dispatch(AMC.GET_ANALYTIC_MODULES, true, { refresh: true })
        commit(AMC.SAVE_MODULE_TOAST_NOTIFICATION, true)
      } else {
        commit(AMC.SAVE_MODULE_TOAST_NOTIFICATION, false)
      }
    } catch (error) {
      console.log(AMC.SAVE_ANALYTIC_MODULE + ': error ' + error)
    }
  },
  async [AMC.GET_ASCENTIA_ANALYTICS_WITH_ALERT_TYPES]({ commit, rootGetters }) {
    try {
      const airlineIds = rootGetters['globalFilter/airlineIdsSelected']
      const masterModelIds = rootGetters['globalFilter/masterModelIdsSelected']

      const response = await services.analyticModule.getData(
        'ascentiaAnalyticsWithAlertTypes',
        { airlineIds, masterModelIds },
        true,
      )
      const data = response.data
      commit(AMC.UPDATE_ASCENTIA_ANALYTICS_WITH_ALERT_TYPES, data)
    } catch (error) {
      console.log(
        AMC.GET_ASCENTIA_ANALYTICS_WITH_ALERT_TYPES + ': error ' + error,
      )
    }
  },

  async [AMC.SAVE_CUSTOM_MX_REC_ENTRY]({ commit, dispatch }, data) {
    try {
      commit(AMC.SAVING_CUSTOM_MX_REC_ENTRY, true)
      const response = await services.analyticModule.saveData(
        'saveCustomRecommendationEntry',
        data,
      )

      if (response.status === 200) {
        dispatch(AMC.GET_CUSTOM_MX_REC_ENTRY, {
          airlineId: data.airlineId,
          analyticModuleId: data.analyticModuleId,
        })
      }
      commit(AMC.SAVING_CUSTOM_MX_REC_ENTRY, false)
    } catch (error) {
      console.log(AMC.SAVE_CUSTOM_MX_REC_ENTRY + ': error ' + error)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
